import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class CrmCaseStatusTeamChange extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            caller: props.Caller,
            loading: false,
            selectedTeamId: this.getDefaultGuid()
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/crm/casestatus/teamchange", {
            id: this.state.id,
            toTeamId: this.state.selectedTeamId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("تغییر با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">تغییر تیم</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">انتخاب تیم مورد نظر</label>
                                            <SelectAsync
                                                isMulti={false}
                                                placeholder="انتخاب تیم"
                                                noOptionsMessage={({ inputValue }) =>
                                                    inputValue ? "نتیجه‌ای یافت نشد" : null
                                                }
                                                defaultOptions={[]}
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null,
                                                }}
                                                loadOptions={(inputValue, callback) => this.loadCrmTeamsOptions(inputValue, callback)}
                                                onChange={e => this.state.selectedTeamId = e.value}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                تغییر
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}